/* eslint-disable */
// Here eslint disable is use to avoid line width error
import React from "react";

const Copy = (props: { className?: string }) => (
  <svg
    {...props}
    id="copy--file"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      id="Tracé_6184"
      data-name="Tracé 6184"
      d="M27.4,14.7,21.3,8.6A1.612,1.612,0,0,0,20,8H12a2.006,2.006,0,0,0-2,2V28a2.006,2.006,0,0,0,2,2H26a2.006,2.006,0,0,0,2-2V16.1A1.974,1.974,0,0,0,27.4,14.7ZM20,10l5.9,6H20ZM12,28V10h6v6a2.006,2.006,0,0,0,2,2h6V28Z"
      fill="currentColor"
    />
    <path
      id="Tracé_6185"
      data-name="Tracé 6185"
      d="M6,18H4V4A2.006,2.006,0,0,1,6,2H20V4H6Z"
      fill="currentColor"
    />
    <rect id="Rectangle_3153" data-name="Rectangle 3153" width="32" height="32" fill="none" />
  </svg>
);

export { Copy };
